import React, { useState } from "react";
import useStyles from "./styles";
import LoginSignUpModal from "../../../Login/loginSignUpModal";
import Box from "@material-ui/core/Box";
import Typography  from "@material-ui/core/Typography";
import DefaultLogo from "../../../../../assets/images/defaultLogo.png";
import Search from "../../../navbarSearch";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Menu from "@material-ui/core/Menu";
import { thumborImageUrl } from "../../../../../Utility";
import { useTheme } from "@material-ui/core/styles";
import MobileNavDrawer from "../11/mobile-navbar";
import Button from "@material-ui/core/Button";
import DragHandle from "@material-ui/icons/DragHandle";
import useMemeberInfo from "../../../../../dataHook/useMemeberInfoHook";
import useNavbarInfo from "../../../../../dataHook/useNavHook";
import useDeviceView from "../../../../../dataHook/useDeviceView";
const Component22 = ({ websiteData, widgetList }) => {
  const classes = useStyles();
  const [showLogin, setShowLogin] = useState(false);
  const [showMenuDrawer, setShowMenuDrawer] = useState(false);
  const [showKnowMore, setShowKnowMore] = useState(null);
  const [showLoginDropDown, setShowLoginDropDown] = useState(false);
  const {deskTopView = false} = useDeviceView();
  const theme = useTheme();
  const {user = {},isLoggedIn} = useMemeberInfo();
  const {logo_url,contentArr  = [],handleLogout=()=>{}} = useNavbarInfo();
  if(contentArr?.length <= 0) return null;
  let [loginObj] = contentArr?.filter((obj) => obj.name == "Login");
  let updatedContentArr = contentArr?.filter((obj) => obj.name != "Login");

  const DropDownType = ({ isBtn = false, items = [] }) => {
    let { name = "", link = "", id = "" } = items;
    if (id == "logout") {
      return <MenuItem onClick={handleLogout}>{name}</MenuItem>;
    } else if (link) {
      return (
        <MenuItem
          style={{
            textTransform: "capitalize",
          }}
          component={"a"}
          href={link}
        >
          {name}
        </MenuItem>
      );
    } else {
      return <MenuItem>{name}</MenuItem>;
    }
  };

  let { dropDownItem: loginDropDown = [] } = loginObj;

  const handleClick = (event) => {
    setShowKnowMore(event.currentTarget);
  };

  const handleClose = () => {
    setShowKnowMore(null);
  };

  const handleClickLogin = (event) => {
    setShowLoginDropDown(event.currentTarget);
  };

  const handleCloseLogin = () => {
    setShowLoginDropDown(null);
  };
  return (
    <>
      <div className={classes.header}>
        <div className={classes.footerHead}>
          <div className={classes.contactContainer}>
            <img
              src={logo_url ? thumborImageUrl(logo_url, 0, 100) : DefaultLogo}
              alt="Logo"
              className={classes.logo}
            />
              <Box display="flex" className={classes.navbar}>
                       {updatedContentArr.map((item) => {
                         let { isDropdown = false, dropDownItem = [] } = item;
                         return isDropdown ? (
                           <Box
                             display={"flex"}
                             flexDirection={"column"}
                             alignItems={"center"}
                             justifyContent={"center"}
                           >
                             <Box
                               aria-controls="simple-menu"
                               aria-haspopup="true"
                               onClick={handleClick}
                               display={"flex"}
                               alignItems={"center"}
                             >
                               <a
                                 href={item.link}
                                 style={{
                                   display: "flex",
                                   alignItems: "center",
                                   gap: "5px",
                                   cursor: "pointer",
                                 }}
                                 className={classes.navItem}
                               >
                                 {item.name}
                                 <ExpandMoreIcon
                                   style={{
                                     color: "inherit",
                                   }}
                                 />
                               </a>
                             </Box>
                             <Menu
                               getContentAnchorEl={null}
                               anchorOrigin={{
                                 vertical: "bottom",
                               }}
                               transformOrigin={{
                                 vertical: "top",
                               }}
                               anchorEl={showKnowMore}
                               keepMounted
                               open={Boolean(showKnowMore)}
                               onClose={handleClose}
                             >
                               {dropDownItem.map((items) => {
                                 let { isBtn = false } = items;
                                 return <DropDownType items={items} isBtn={isBtn} />;
                               })}
                             </Menu>
                           </Box>
                         ) : (
                           <a href={item.link} className={classes.navItem}>
                             {item.name}
                           </a>
                         );
                       })}
                     </Box>
            
          </div>
          <div className={classes.loginContainer}>
            {deskTopView && <Search type="NAVBAR_SEARCH_5" />}
            {isLoggedIn ? (
              <>
                <Box
                  style={{ cursor: "pointer" }}
                  display={"flex"}
                  onClick={handleClickLogin}
                >
                  <Typography
                    style={{ color: theme.agentTheme.card.link_foreground }}
                  >
                    {" "}
                    {`Hi ${user?.username || ''}`}
                  </Typography>
                  <Box display={"flex"}>
                    <ExpandMoreIcon
                      style={{ color: theme.agentTheme.card.link_foreground }}
                    />
                  </Box>
                </Box>
                <Menu
                  getContentAnchorEl={null}
                  anchorOrigin={{
                    vertical: "bottom",
                  }}
                  transformOrigin={{
                    vertical: "top",
                  }}
                  anchorEl={showLoginDropDown}
                  keepMounted
                  open={Boolean(showLoginDropDown)}
                  onClose={handleCloseLogin}
                  className={classes.dropdownContainerLogin}
                  PaperProps={{
                    style: {
                      borderTop: `2px solid ${theme?.agentTheme?.primary?.main}`,
                      borderRadius: 0,
                      marginTop: "1rem",
                    },
                  }}
                >
                  {loginDropDown?.map((items, index) => {
                    let { isBtn = false } = items;
                    const isLast = index === loginDropDown?.length - 1;
                    return (
                      <div
                        key={items?.id || index}
                        style={{
                          borderBottom: !isLast
                            ? `1px solid ${theme?.agentTheme?.text?.small_text_color}`
                            : "none",
                          padding: "0.3rem",
                        }}
                      >
                        <DropDownType items={items} isBtn={isBtn} />
                      </div>
                    );
                  })}
                </Menu>
              </>
            ) : (
              <Button
                variant="contained"
                className={classes.becomeExpertBtn}
                onClick={() => setShowLogin(true)}
              >
                Login
              </Button>
            )}
          </div>
        </div>
        <div>
          <Box
            display="flex"
            alignItems="center"
            style={{
              padding: "20px 14px",
            }}
            className={classes.menu}
          >
            <div className={classes.contactContainer}>
              <DragHandle
                className={classes.menuIcon}
                style={{
                  fontSize: "2rem",
                  cursor: "pointer",
                }}
                onClick={() => setShowMenuDrawer(true)}
              />
              <img
                 src={logo_url ? thumborImageUrl(logo_url, 0, 100) : DefaultLogo}
                alt="Logo"
                className={classes.logo}
              />
            </div>
           <MobileNavDrawer
                         widgetList={widgetList}
                         websiteData={websiteData}
                         showDrawer={showMenuDrawer}
                         setShowDrawer={setShowMenuDrawer}
                         contentArr={contentArr}
                       />
          </Box>

          
        </div>
      </div>
      {showLogin && <LoginSignUpModal onClose={() => setShowLogin(false)} />}
    </>
  );
};

export default Component22;
